import { Checkbox, Collapse, Stack, Text, Textarea } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useWidgetFormContext } from '@/components/Widget/Embed/form-context';
import { useWidgetForm } from '@/hooks/useWidgetForm';

export const MultiLanguageTitle = ({ chatbotCollapseOpened }: { chatbotCollapseOpened: boolean }) => {
  const { t } = useTranslation();
  const { form } = useWidgetFormContext();
  const { onOverrideChangeForForm } = useWidgetForm();

  return (
    <Stack>
      <Checkbox
        label={<Text>{t('widget.setting.chatbot.multi_language_title_label')}</Text>}
        checked={form.values.chatbot.multiLanguageTitle.checked}
        {...form.getInputProps('chatbot.multiLanguageTitle.checked')}
        onChange={onOverrideChangeForForm('chatbot.multiLanguageTitle.checked')}
      />
      <Collapse in={chatbotCollapseOpened && form.values.chatbot.multiLanguageTitle.checked}>
        <Stack gap="sm" className="border rounded-lg p-3">
          <Textarea
            label={<Text size="xs">中文</Text>}
            disabled={!form.values.chatbot.multiLanguageTitle.checked}
            autosize
            minRows={1}
            {...form.getInputProps('chatbot.multiLanguageTitle.values.zh')}
            onBlur={onOverrideChangeForForm('chatbot.multiLanguageTitle.values.zh')}
          />
          <Textarea
            label={<Text size="xs">English</Text>}
            disabled={!form.values.chatbot.multiLanguageTitle.checked}
            autosize
            minRows={1}
            {...form.getInputProps('chatbot.multiLanguageTitle.values.en')}
            onBlur={onOverrideChangeForForm('chatbot.multiLanguageTitle.values.en')}
          />
          <Textarea
            label={<Text size="xs">日本語</Text>}
            disabled={!form.values.chatbot.multiLanguageTitle.checked}
            autosize
            minRows={1}
            {...form.getInputProps('chatbot.multiLanguageTitle.values.ja')}
            onBlur={onOverrideChangeForForm('chatbot.multiLanguageTitle.values.ja')}
          />
          <Textarea
            label={<Text size="xs">한국어</Text>}
            disabled={!form.values.chatbot.multiLanguageTitle.checked}
            autosize
            minRows={1}
            {...form.getInputProps('chatbot.multiLanguageTitle.values.ko')}
            onBlur={onOverrideChangeForForm('chatbot.multiLanguageTitle.values.ko')}
          />
        </Stack>
      </Collapse>
    </Stack>
  );
};
